import { InMemoryHeader, InMemoryString } from "pbas-vue-components";
import { i18n } from "@/plugins/i18n";

function getHeaders(languages) {
  const headers = [
    new InMemoryHeader({
      type: new InMemoryString("Identifier"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
  ];
  for (const lang of languages) {
    headers.push(
      new InMemoryHeader({
        title: i18n.t(`headers.left_drawer_menu_items.title_{0}`, [lang.language.toUpperCase()]),
        type: new InMemoryString(`Title${lang.language.toUpperCase()}`),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      })
    );
  }
  headers.push(
    new InMemoryHeader({
      title: "headers.left_drawer_menu_items.url",
      type: new InMemoryString("Url"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    })
  );
  return headers;
}
export default getHeaders;
